import { CRASH_GAME_NAMES, type CrashGameName } from '~/types/crash-pre-game';

// Ponte entre o slug do jogo no catálogo do site e o `game_name` da API de
// crash. Os dois NÃO são iguais: no catálogo o Aviator 2 é `spribe/aviator2`
// (sem hífen) e a API o chama de `aviator-2`. Deixar o componente montar essa
// string na mão é o caminho curto pra um 422 silencioso em produção.
//
// O mapa é explícito de propósito: só entra jogo que o core aceita
// (whitelist de CRASH_GAME_NAMES). `banana/aviator-crash`, por exemplo, é
// outro jogo e fica de fora — sem coletor, não há histórico pra mostrar.
const CRASH_GAME_NAME_BY_SLUG: Record<string, CrashGameName> = {
  'spribe/aviator': 'aviator',
  'spribe/aviator2': 'aviator-2',
  'spribe/aviator-2': 'aviator-2',
};

// Devolve o `game_name` da API para um slug de jogo, ou null quando o jogo não
// é um crash com histórico disponível — e null é o sinal que a UI usa pra não
// renderizar o bloco (e pra não fazer a request).
export function resolveCrashGameName(
  slug?: string | null,
): CrashGameName | null {
  if (!slug) return null;

  const normalized = slug.trim().toLowerCase();

  return CRASH_GAME_NAME_BY_SLUG[normalized] ?? null;
}

export function isCrashGameName(value: unknown): value is CrashGameName {
  return CRASH_GAME_NAMES.includes(value as CrashGameName);
}
